/**
 * Send customers straight to checkout when they add something to the cart.
 *
 * Two routes into the cart exist in this theme and both are covered here:
 *
 *   1. Native form posts. The custom Hoshi product pages submit /cart/add
 *      directly, and Shopify honours a return_to field on that post, so no
 *      redirect of our own is needed — and it keeps working with JavaScript
 *      off.
 *
 *   2. AJAX adds. The theme's own product form and quick-add buttons fetch
 *      /cart/add and announce the result with shopify:cart:lines-update. We
 *      wait on the promise that event carries, so a rejected add leaves the
 *      customer where they are with the theme's error message rather than
 *      dropping them into an unchanged checkout.
 *
 * Only additions redirect. Quantity edits and removals inside the cart fire
 * the same event and must be left alone.
 */
(() => {
  if (window.hoshiDirectCheckout) return;

  // Looked up by id rather than document.currentScript, which is null for a
  // deferred script.
  const script = document.getElementById('hoshi-direct-checkout');
  const CHECKOUT = (script && script.dataset.checkoutUrl) || '/checkout';

  window.hoshiDirectCheckout = { url: CHECKOUT };

  const go = () => {
    window.location.href = CHECKOUT;
  };

  /* 1. Native posts ------------------------------------------------------ */
  // Capture phase, so the field is in place even if something else handles
  // the submit first.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      if (form.querySelector('[name="return_to"]')) return;

      const field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'return_to';
      field.value = CHECKOUT;
      form.appendChild(field);
    },
    true
  );

  /* 2. AJAX adds --------------------------------------------------------- */
  document.addEventListener('shopify:cart:lines-update', (event) => {
    // The payload has been seen on both the event and its detail across
    // theme versions, so read whichever carries the action.
    const data = (event.detail && event.detail.action ? event.detail : event) || {};
    if (data.action !== 'add') return;

    const pending = data.promise;
    if (pending && typeof pending.then === 'function') {
      pending
        .then((result) => {
          if (!(result && result.detail && result.detail.didError)) go();
        })
        .catch(() => {
          /* the theme surfaces the failure; stay put */
        });
      return;
    }

    go();
  });
})();
